export interface DashboardMenuItem {
	label: string,
	label_collapsed?: string,
	/** if internal link add RouterLink */
	routerLink?: string,
	/** if external link add URL */
	url?: string,
	target?: string,
	icon: string,
	subMenu?: DashboardMenuItem[],
	separator?: boolean,
}

export const EMPTY_DASHBOARD_FRAME_CONFIG: DashboardFrameConfig = {
	environmentName: 'DEV',
	signOut: () => { },
	menu: [],
};

export interface DashboardFrameConfig {
	// The application name ('public', 'staff', etc)
	appName?: 'Admin' | 'Dashboard' | 'Devo' | 'Programs',
	environmentName: 'DEV' | 'PROD' | 'LOCALHOST',
	menu: DashboardMenuItem[],
	signOut: () => void,
}